export const getSource = (url: string) => {
  const urlObj = new URL(url);
  const host = urlObj.hostname;
  if (host.includes('youtube')) {
    return 'youtube';
  }
  return 'podcast';
};

export const formatDate = (date: string) => {
  const dateTime = new Date(date);
  return dateTime.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
};

export const getEpisodeUrl = (title: string, feedId: string, episodeId: string) => {
  const slug = title.toLowerCase().replace(/[^a-z0-9-]/g, '-');
  const encodedEpisodeId = encodeURIComponent(episodeId);
  return `/podcast/${slug}/${feedId}/${encodedEpisodeId}`;
};
